import classNames from 'classnames';
import React, { useEffect } from 'react';
import useErrorTrack from '../../hooks/analytics/use-error-track';
import { ErrorType } from '../../types/analytics';
import { FAIL_TYPE_AUTH_TOKEN_RESENT } from '../../utils/auth-errors';
import { Anchor } from '../anchor';
import './message.sass';

export enum MessageType {
  ERROR = 'error',
  SUCCESS = 'success',
  HINT = 'hint',
}

interface MessageProps {
  id?: string;
  message: string;
  link?: string;
  onClick?: () => void;
  parentClass?: string;
  errorCode?: number | null;
  type: MessageType.HINT | MessageType.SUCCESS;
}

interface ErrorMessageProps extends Omit<MessageProps, 'type'> {
  canRetry?: boolean;
  component: string;
  errorType: ErrorType;
  type: MessageType.ERROR;
}

type ComponentProps = MessageProps | ErrorMessageProps;

export default function Message(props: ComponentProps) {
  const { type, message, link = '', onClick, parentClass, errorCode, id } = props;

  const { handleErrorDisplayedTrack } = useErrorTrack();

  const handleClick = () => {
    onClick?.();
  };

  const handleTrackErrorMessage = () => {
    if ('errorType' in props) {
      const { errorType, component, canRetry } = props;
      handleErrorDisplayedTrack({
        message,
        errorType,
        component,
        canRetry: !!canRetry,
        code: errorCode ? Number(errorCode) : undefined,
      });
    }
  };

  useEffect(() => {
    if (message && type === MessageType.ERROR) {
      handleTrackErrorMessage();
    }
  }, [message]);

  const messageClasses = classNames({
    'message-error': type === MessageType.ERROR,
    'message-success': type === MessageType.SUCCESS,
    'message-hint': type === MessageType.HINT,
    'message-code-resent': errorCode === FAIL_TYPE_AUTH_TOKEN_RESENT,
  });

  return (
    <div className={parentClass}>
      <div className={messageClasses} id={id}>
        <Choose>
          <When condition={!!link}>
            <Anchor href={link} onClick={handleClick}>
              {message}
            </Anchor>
          </When>
          <Otherwise>{message}</Otherwise>
        </Choose>
      </div>
    </div>
  );
}
